require('../../../node_modules/bootstrap/dist/css/bootstrap.min.css');

export default {
  name: 'app',
  created: function() {
    if (!this.$store.getters.isLogin && window.localStorage.getItem('access_token')) {
      this.authorize()
    }
  },
  components: {
  },
  methods: {
    authorize: function() {
      this.$store.dispatch('AUTHORIZE')
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/other.js